import * as types from "./brasao.actionsType";

export default {
  getBrasao: () => ({
    type: types.GET_BRASAO
  }),
  setBrasao: urlBrasao => ({
    type: types.SET_BRASAO,
    payload: urlBrasao
  })
};
